export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '广州番禺区番禺大道555号天安科技园2号楼1801',
  uc_host: 'http://user.shangmeitong.com',
  site_host: 'http://www.shangmeitong.com',
  special_url: '/',
  site_title: '商媒通-软文精准营销平台',
  welcome_title: '商媒通 — 软文精准营销平台！',
  site_short_title: '商媒通',
  site_subtitle: '软文精准营销平台',
  company_name: '中商传媒（广州）有限公司',
  copyright: '© 2025 中商传媒（广州）有限公司',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/250821/fccb6464fd87920d9806995150088681.png',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/250821/d68fd5a83b424514d7d65e7b7c01f753.png',
  payment: '',
  qq: '',
  tel: '18602007705',
  company_account_id: '3602078209200336746',
  company_bank: '中国工商银行广州元岗支行',
  company_bank_name: '中商传媒（广州）有限公司',
  alipay_account_id: '42354035@qq.com',
  alipay_name: '中商传媒(广州)有限公司',
  alipay_pic: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/250901/15ee37bb7b39148908f17a3502641da5.jpg',
  section_id: 679112,
  belonger_id: 679112,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 